import http from '@/libs/http'
const baseUrl = process.env.VUE_APP_MICROSERVICE_API_UT_SEGUPHARMA_CONFIG_OV

export default class PacientesService {
  listarPacientes (params) {
    return http.get(`${baseUrl}/pacientes/search`, {
      params,
      headers: {
        loading: true
      }
    })
  }

  listarTiposId () {
    return http.get(`${baseUrl}/pacientes/tipos-id`, {
      headers: {
        loading: true
      }
    })
  }

  tiposIdentificacion () {
    return http.get(`${baseUrl}/tipos-identificacion/obtener-tipos-identificacion`, {
      headers: {
        loading: true
      }
    })
  }

  listarHistoriaClinica (params) {
    return http.get(`${baseUrl}/pacientes/historia-clinica`, {
      params,
      headers: {
        loading: true
      }
    })
  }

  actualizarPaciente (body, id) {
    return http.put(`${baseUrl}/pacientes/actualizar-paciente/${id}`, body, {
      headers: {
        loading: true
      }
    })
  }

  paginate (params) {
    return http.get(`${baseUrl}/pacientes/paginate`, {
      params,
      headers: {
        loading: true
      }
    })
  }

  listPacienteSync (params) {
    return http.get(`${baseUrl}/pacientes/paginate-sync`, {
      params,
      headers: {
        loading: true
      }
    })
  }

  sync (data) {
    return http.post(`${baseUrl}/pacientes/sync`, data, {
      headers: {
        loading: true
      }
    })
  }

  getPac (id) {
    return http.get(`${baseUrl}/pacientes/find/${id}`, {
      headers: {
        loading: true
      }
    })
  }

  crearPac (data) {
    return http.post(`${baseUrl}/pacientes`, data, {
      headers: {
        loading: true
      }
    })
  }

  editarPac (data, id) {
    return http.put(`${baseUrl}/pacientes/actualizar-paciente/${id}`, data, {
      headers: {
        loading: true
      }
    })
  }

  eliminarPac (id) {
    return http.delete(`${baseUrl}/pacientes/${id}`, {
      headers: {
        loading: true
      }
    })
  }

  getCiudades (nombre = '') {
    return http.get(`${baseUrl}/localizacion/search/${nombre}`, {
      headers: {
        loading: true
      }
    })
  }

  getDptos (nombre = '') {
    return http.get(`${baseUrl}/localizacion/listar-departamentos/${nombre}`, {
      headers: {
        loading: true
      }
    })
  }

  getEntidades = (nombre = '') => {
    return http.get(`${baseUrl}/ov-entidad/search/${nombre}`, {
      headers: {
        loading: true
      }
    })
  }

  getClientes = (nombre = '') => {
    return http.get(`${baseUrl}/ov-cliente/search/${nombre}`, {
      headers: {
        loading: true
      }
    })
  }
}
